import { Component, OnInit } from '@angular/core'
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog'

@Component({
  selector: 'jml-lib-script-result-dialog',
  templateUrl: './script-result-dialog.component.html',
  styleUrls: ['./script-result-dialog.component.scss']
})
export class ScriptResultDialogComponent implements OnInit {
  actionResponse

  constructor(private config: DynamicDialogConfig) {}

  ngOnInit(): void {
    this.actionResponse = this.config.data.actionResponse
  }
}
